"use strict";

var cart = require("../cart/cart");
var gtmHelpers = require("../helpers/gtmHelpers");
var fitMiniCartToViewport = require("./miniCartHeight");

var updateMiniCart = true;

/**
 * DGF-4835: the line items in a basket-update payload, whichever shape the route returned: the cart
 * model itself (Cart-UpdateQuantity), `{ basket }` (Cart-RemoveProductLineItem), `{ cart }`
 * (Cart-AddProduct) or `{ cartModel }`.
 * @param {Object} payload - the AJAX response or event data
 * @returns {Array|null} the items, or null when the payload doesn't carry them
 */
function findItems(payload) {
    if (!payload) {
        return null;
    }
    var candidates = [payload, payload.basket, payload.cart, payload.cartModel];
    for (var i = 0; i < candidates.length; i++) {
        if (candidates[i] && Array.isArray(candidates[i].items)) {
            return candidates[i].items;
        }
    }
    return null;
}

/**
 * DGF-4835: shows or hides the red dot on the header bag icon, and keeps the same fact in the bag
 * link's accessible name, since the dot itself is aria-hidden. Runs after the handlers that reset the
 * label to the item count, so it only ever adds or removes its own suffix.
 * @param {boolean} needsAttention - whether any line in the basket can't be ordered
 */
function setMiniCartAttention(needsAttention) {
    $(".minicart .minicart-attention-dot").toggleClass("d-none", !needsAttention);
    $(".minicart .minicart-link").each(function () {
        var $link = $(this);
        var suffix = ". " + $link.data("attentionLabel");
        var label = String($link.attr("aria-label") || "");
        if (label.slice(-suffix.length) === suffix) {
            label = label.slice(0, -suffix.length);
        }
        if (needsAttention) {
            label += suffix;
        }
        $link.attr({ "aria-label": label, title: label });
    });
}

/**
 * DGF-4835: re-derives the dot from a basket-update payload. Leaves it alone when the payload carries
 * no line items, rather than guessing.
 * @param {Object} payload - the AJAX response or event data
 */
function updateMiniCartAttention(payload) {
    var items = findItems(payload);
    if (items) {
        var model = [payload, payload.basket, payload.cart, payload.cartModel].filter(function (candidate) {
            return candidate && candidate.items === items;
        })[0];
        // Auto-removed items (DGF-4835) count too, even once the basket itself is empty.
        var hasRemovedItems = Boolean(model && Array.isArray(model.removedItems) && model.removedItems.length);
        setMiniCartAttention(hasRemovedItems || items.some(function (item) { return item.available === false; }));
    }
}

/**
 * DGF-4835: fills the "Notify me when available" popup (checkout/cart/backInStockModal.isml) for the sold-out product
 * whose "Email me when it is back" button opened it (checkout/cart/backInStockToggle.isml), and resets it from any
 * earlier use. The popup's markup is in the page header, which can be page-cached, so everything product- or
 * customer-specific comes from the button, rendered with the uncached bag or basket.
 * @param {jQuery} $modal - the popup
 * @param {jQuery} $toggle - the button that opened it
 */
function fillBackInStockModal($modal, $toggle) {
    var image = $toggle.data("image");
    var $form = $modal.find(".back-in-stock-modal__form");

    $modal.find(".back-in-stock-modal__name").text($toggle.data("name") || "");
    $modal.find(".back-in-stock-modal__details").text($toggle.data("details") || "");
    $modal.find(".back-in-stock-modal__image")
        .attr({ src: image || "", alt: $toggle.data("imageAlt") || "" })
        .toggleClass("d-none", !image);

    $form.find("input[name='productId']").val(String($toggle.data("pid") || ""));
    $form.find("input[name='apiEventName']").val($toggle.data("eventName") || "");
    $form.find(".back-in-stock-modal__csrf").attr("name", $toggle.data("tokenName") || "").val($toggle.data("token") || "");
    $form.find(".back-in-stock-modal__email").val($toggle.data("email") || "");
    $form.find(".back-in-stock-modal__optin").prop("checked", String($toggle.data("optInDefault")) === "true");

    $form.find(".back-in-stock-modal__fields").removeClass("d-none");
    $form.find(".back-in-stock-modal__submit").prop("disabled", false);
    $form.find(".back-in-stock-modal__result").text("").removeClass("back-in-stock-modal__result--error");
}

/**
 * DGF-4835: posts one of a removed item's card actions (checkout/cart/removedItemCard.isml): "Remove" / × to
 * Cart-DismissRemovedItem, "Save to wishlist" to Cart-SaveRemovedItemToWishlist. Both drop the card from the
 * basket's removed-items list. The mini bag then re-renders; the basket page reloads, so its sections and counts
 * are rebuilt server-side.
 * @param {jQuery} $button - the action's button, carrying the URL, pid and CSRF token
 */
function postRemovedItemAction($button) {
    var data = { pid: $button.data("pid") };
    data[$button.data("tokenName")] = $button.data("token");

    $button.prop("disabled", true);
    $.ajax({
        url: $button.data("url"),
        type: "post",
        dataType: "json",
        data: data,
        success: function (response) {
            if (!response || !response.success) {
                // Nothing was done (no basket, no pid, or the wishlist refused it): leave the card as it is.
                $button.prop("disabled", false);
                return;
            }
            if (response.gtmObject && typeof gtmHelpers.cartEvents === "function") {
                gtmHelpers.cartEvents(response.gtmObject);
            }
            if (typeof response.basketNeedsAttention === "boolean") {
                setMiniCartAttention(response.basketNeedsAttention);
            }
            updateMiniCart = true;
            if ($button.closest(".minicart").length) {
                loadMiniCart($(".minicart").data("action-url"));
            } else {
                window.location.reload();
            }
        },
        error: function (err) {
            // A rejected CSRF token comes back from CSRF-AjaxFail with a redirectUrl; follow it, as the
            // basket's other AJAX handlers do (js/cart/cart.js).
            if (err && err.responseJSON && err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
                return;
            }
            $button.prop("disabled", false);
        }
    });
}

/**
 * Fetches and renders the mini bag into its (already shown) popover.
 * @param {string} url - the Cart-MiniCartShow URL
 */
function loadMiniCart(url) {
    $(".minicart .popover").spinner().start();
    $.get(url, function (data) {
        $(".minicart .popover").empty();
        if (data.isBasketEmpty) {
            $(".minicart .minicart-quantity").text(0);
            setMiniCartAttention(false);
            // DGF-4835: an empty basket can now be open (removed items listed, count 0); dismissing the last of
            // them must not leave a blank popover under the header.
            $(".minicart .popover").removeClass("show");
        } else {
            $(".minicart .popover").append(data.html);
            fitMiniCartToViewport();
            $(".minicart .minicart-quantity").text(data.productQty);
            // DGF-4835: the label is reset to the current count before setMiniCartAttention adds its suffix;
            // auto-remove in Cart-MiniCartShow can have changed the count since the header was rendered.
            if (data.minicartCountOfItems) {
                $(".minicart .minicart-link").attr({
                    "aria-label": data.minicartCountOfItems,
                    title: data.minicartCountOfItems
                });
            }
            // DGF-4835: the freshly rendered bag is the most current answer.
            setMiniCartAttention($(".minicart .popover .minicart-sold-out").length > 0);
        }
        updateMiniCart = false;
        $.spinner().stop();
    });
}

module.exports = function () {
    cart();

    $(".minicart").on("count:update", function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $(".minicart .minicart-quantity").text(count.quantityTotal);
            $(".minicart .minicart-link").attr({
                "aria-label": count.cart.resources.minicartCountOfItems,
                title: count.cart.resources.minicartCountOfItems
            });
            updateMiniCartAttention(count);
        }
    });

    $(".minicart").on("mouseenter focusin touchstart", function () {
        if (window.matchMedia("(max-width: 991px)").matches) {
            return;
        }

        var url = $(".minicart").data("action-url");
        var count = parseInt($(".minicart .minicart-quantity").text(), 10);

        // DGF-4835: a basket emptied by auto-remove has a count of 0 but still has removed items to show.
        var hasAttention = $(".minicart .minicart-attention-dot").not(".d-none").length > 0;

        if ((count !== 0 || hasAttention) && $(".minicart .popover.show").length === 0) {
            if (!updateMiniCart) {
                $(".minicart .popover").addClass("show");
                fitMiniCartToViewport();
                return;
            }

            $(".minicart .popover").addClass("show");
            fitMiniCartToViewport();
            loadMiniCart(url);
        }
    });
    $("body").on("touchstart click", function (e) {
        if ($(".minicart").has(e.target).length <= 0) {
            $(".minicart .popover").removeClass("show");
        }
    });
    $(".minicart").on("mouseleave focusout", function (event) {
        if ((event.type === "focusout" && $(".minicart").has(event.target).length > 0)
            || (event.type === "mouseleave" && $(event.target).is(".minicart .quantity"))
            // Also keeps the bag open under the DGF-4835 back-in-stock popup.
            || $("body").hasClass("modal-open")) {
            event.stopPropagation();
            return;
        }
        $(".minicart .popover").removeClass("show");
    });
    $("body").on("change", ".minicart .quantity", function () {
        if ($(this).parents(".bonus-product-line-item").length && $(".cart-page").length) {
            location.reload();
        }
    });
    $("body").on("product:afterAddToCart", function () {
        updateMiniCart = true;
    });

    // DGF-4835: "Email me when it is back" on a sold-out card, in the mini bag or on the basket page, opens the
    // "Notify me when available" popup for that product. Focus goes back to the button when it closes.
    $("body").on("click", ".back-in-stock-toggle", function () {
        var $toggle = $(this);
        var $modal = $("#backInStockModal");
        if (!$modal.length) {
            return;
        }

        fillBackInStockModal($modal, $toggle);
        $modal.one("shown.bs.modal", function () {
            $modal.find(".back-in-stock-modal__email").trigger("focus");
        });
        $modal.one("hidden.bs.modal", function () {
            $toggle.trigger("focus");
        });
        $modal.modal("show");
    });

    // DGF-4835: × / "Remove" ("Remove from bag" on the basket page) and "Save to wishlist" on an auto-removed item.
    $("body").on("click", ".removed-item-dismiss, .removed-item-save-wishlist", function () {
        postRemovedItemAction($(this));
    });

    // DGF-4835: posts to EmailSubscribe-NotifyMe, as the PDP's notify-me form does. The result is
    // written to the popup's role="status" element so screen readers announce it.
    $("body").on("submit", ".back-in-stock-modal__form", function (e) {
        e.preventDefault();
        var form = this;
        var $form = $(form);
        var $result = $form.find(".back-in-stock-modal__result");
        var $submit = $form.find(".back-in-stock-modal__submit");

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        $submit.prop("disabled", true);
        $.ajax({
            url: $form.attr("action"),
            type: "post",
            dataType: "json",
            data: $form.serialize(),
            success: function (data) {
                var succeeded = Boolean(data && data.success);
                $result.text((data && data.msg) || (succeeded ? "" : $form.data("errorMessage")))
                    .toggleClass("back-in-stock-modal__result--error", !succeeded);
                if (succeeded) {
                    $form.find(".back-in-stock-modal__fields").addClass("d-none");
                }
                $submit.prop("disabled", false);
            },
            error: function () {
                $result.text($form.data("errorMessage")).addClass("back-in-stock-modal__result--error");
                $submit.prop("disabled", false);
            }
        });
    });
    $("body").on("cart:update", (event, params) => {
        updateMiniCart = true;
        updateMiniCartAttention(params);
        // DGF-4835: a removal inside the open mini bag only deletes that card, which would leave the
        // "Needs your attention (n)" / "Ready to order (n)" titles and counts stale (or a title over an
        // empty section). Re-render it while it's open; a closed one re-renders on next open anyway.
        if ($(".minicart .popover.show .minicart-section-title").length) {
            loadMiniCart($(".minicart").data("action-url"));
        }
        // The basket page has the same titled sections (cart/cart.isml), and its handlers (js/cart/cart.js) only
        // remove a card or update a line in place, which can leave a section's title and count wrong, or a title
        // over nothing. Reload so they're rebuilt server-side; only a basket with sections showing is affected.
        if ($(".cart-page .cart-section-title").length) {
            window.location.reload();
        }
        let cartModel = params;

        if ("cartModel" in cartModel) {
            cartModel = params.cartModel;
        }

        if ("basket" in cartModel) {
            cartModel = params.basket;
        }

        if (!cartModel?.showRemovedGivexCardsModal) return;

        $("body").trigger("givex:removed", { showRemovedGivexCardsModal: cartModel.showRemovedGivexCardsModal });
    });
};
